import { createContext, useContext, useState, ReactNode, useEffect } from "react";
import { useUserSettings } from "./UserSettingsContext";

type CountryContextType = {
    country: string;
    setCountry: (country: string) => void;
};

const CountryContext = createContext<CountryContextType | undefined>(undefined);

export const CountryProvider = ({ children }: { children: ReactNode }) => {
    const { userCountry } = useUserSettings();
    const [country, setCountry] = useState<string>("US"); // US is Default country

    useEffect(() => {
        if (userCountry) {
            setCountry(userCountry);
        }
    }, [userCountry]);

    return <CountryContext.Provider value={{ country, setCountry }}>{children}</CountryContext.Provider>;
};

export const useCountry = () => {
    const context = useContext(CountryContext);
    if (!context) {
        throw new Error("useCountry must be used within a CountryProvider");
    }
    return context;
};
